<script setup>
import { useForm } from '@inertiajs/vue3';
import AppButton from './AppButton.vue';

const props = defineProps({
    href: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        default: 'primary',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    method: {
        type: String,
        default: 'get',
    },
    data: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const form = useForm({
    _method: props.method,
    ...props.data,
});

const submit = () => {
    if (form.processing) {
        return;
    }
    form.submit(props.method, props.href, {
        preserveScroll: true,
    });
};
defineOptions({
    name: 'InertiaLinkButton',
});
</script>

<template>
    <form action="" @submit.prevent="submit" :disabled="form.processing || disabled">
        <AppButton
            v-bind="$attrs"
            :desired-action="type !== 'white'"
            element="button"
            type="submit"
            :disabled="form.processing || disabled"
        >
            <slot />
            <span v-if="form.processing" class="ml-1 btn-spinner" />
        </AppButton>
    </form>
</template>
